// `contract_status` is optional on a vendor record — rows created before the field existed,
// and rows created through the Excel bulk upload (whose template has no status column), come
// back null. Falling straight through to "Pending" made every such vendor look like it was
// waiting on a contract, so derive from the contract dates first and let the list and the
// detail page agree on the answer.

export const CONTRACT_STATUSES = ['Active', 'Pending', 'Expired'];

const endOfDay = (value) => {
    const dt = new Date(value);
    if (Number.isNaN(dt.getTime())) return null;
    dt.setHours(23, 59, 59, 999);
    return dt;
};

/**
 * @param {object} vendor raw vendor row from the API (snake_case fields)
 * @returns {'Active'|'Pending'|'Expired'}
 */
export const resolveContractStatus = (vendor) => {
    if (vendor?.contract_status) return vendor.contract_status;

    const end = endOfDay(vendor?.contract_end_date);
    if (end) return end >= new Date() ? 'Active' : 'Expired';

    // A start date with no end date is an open-ended contract, not a pending one.
    return vendor?.contract_start_date ? 'Active' : 'Pending';
};
